module.exports = __webpack_public_path__ + "img/信息采集平台_技术结构图.0d08830c.png";